export const SOCIAL_MANAGER_PAGES_ORDER_FOR_PERMISSIONS: string[] = ['program', 'public_agent_module_permission', 'group_module_permission']
